import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import 'datatables.net'; // Import DataTables
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import { storage, ref, uploadBytesResumable, getDownloadURL, db, collection, addDoc, doc, getDoc, setDoc, getDocs, deleteDoc, updateDoc, writeBatch, query, where } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import EditSoal from './form/EditSoal';
import Maping from "./form/Maping.js";
import Swal from "sweetalert2";
import Compressor from 'compressorjs';

import {
    handleBold,
    handleItalic,
    handleUnderline,
    handleList,
    handleOrderedList,
} from "../../utils/editorFunctions";
const ViewEvaluasi = () => {
    const [data, setData] = useState([]); // State untuk menyimpan daftar kelas
    const location = useLocation(); // Gunakan useLocation untuk membaca query string
    const queryParams = new URLSearchParams(location.search);
    const id_ujian = queryParams.get('id_ujian');
    const [isBold, setIsBold] = useState(false);
    const [isItalic, setIsItalic] = useState(false);
    const [isUnderline, setIsUnderline] = useState(false);
    const [isList, setIsList] = useState(false);
    const [isListNumber, setListNumber] = useState(false);
    const [editors, setEditors] = useState(["text-editor"]);
    const navigate = useNavigate();
    const [jenis, setJenis] = useState(""); // Untuk menyimpan jenis jawaban
    const [jawaban, setJawaban] = useState([]); // Array jawaban
    const [soalmap, setSoalmap] = useState([]); // Array jawaban
    const [informasiAkun, setInformasiAkun] = useState(null); // State untuk menyimpan informasi akun
    const progressRef = useRef(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [loadngloadData, setIsloadngloadData] = useState(false);
    const [poin, setPoin] = useState(1);

    const didMount = useRef(false);
    const prevImagesRef = useRef([]); // Untuk menyimpan gambar sebelumnya
    const [selectedSoal, setSelectedSoal] = useState(null);
    const [gform, setGform] = useState([]);

    const [soalGformPilih, setSoalGformPilih] = useState([]);
    const [soallis, setSoalList] = useState([]);
    const [soallisid, setSoalListId] = useState([]);

    const [fetchTrigger, setFetchTrigger] = useState(0); // State pemicu fetch ulang



    const overlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Transparan
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        color: "#fff",
        fontSize: "20px",
    };

    var editor = document.getElementById("text-editor");

    const getAkun = async () => {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
            console.error("Token required");
            return; // Jika tidak ada token, hentikan eksekusi
        }

        try {
            // Decode payload dari token JWT
            const decoded = jwtDecode(authToken);
            setInformasiAkun(decoded);
        } catch (error) {
            navigate('/login'); // Jika token tidak valid, arahkan ke halaman login
            return;
        }

    }


    const fetchKelas = async () => {
        setIsloadngloadData(true)
        setSoalList([]);

        try {
            // Kirim request ke server dengan header level user
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/viewevaluasi?id_ujian=${id_ujian}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch kelas");
            }

            const data = await response.json();

            // Menyimpan data kelas ke dalam state
            setData(data.data);
            let soalid = []
            if (data.data.soal) {
                soalid = JSON.parse(data.data.soal)
            }
            setSoalListId(soalid)
            const results = await getDocumentsByIds(soalid);
            results.sort((a, b) => {
                return (a.id_soal || 0) - (b.id_soal || 0);
            });
            // Simpan daftar soal ke state
            setSoalList(results);
            setIsloadngloadData(false)
        } catch (error) {
            setIsloadngloadData(false)

        }

        // try {
        //     const ujianRef = doc(db, "ujian", id_ujian);
        //     const ujianSnap = await getDoc(ujianRef);

        //     if (!ujianSnap.exists()) {
        //         setIsloadngloadData(false)
        //         throw new Error("Ujian tidak ditemukan!");
        //     }

        //     // Simpan data ujian ke state
        //     setData(ujianSnap.data());

        //     // Ambil daftar soal dari subkoleksi "ujian/{id_ujian}/soal"
        //     const soalRef = collection(db, `ujian/${id_ujian}/soal`);
        //     const soalSnap = await getDocs(soalRef);

        //     if (!soalSnap.empty) {
        //         let soalList = [];

        //         for (const soalDoc of soalSnap.docs) {
        //             const soalId = soalDoc.data().soalId; // Ambil referensi ID soal

        //             // Ambil detail soal dari koleksi utama "soal"
        //             const soalDetailRef = doc(db, "soal", soalId);
        //             const soalDetailSnap = await getDoc(soalDetailRef);

        //             if (soalDetailSnap.exists()) {
        //                 soalList.push({
        //                     id: soalId,
        //                     ...soalDetailSnap.data()
        //                 });
        //             }
        //         }
        //         console.log(soalList)
        //         soalList.sort((a, b) => {
        //             return (a.id_soal || 0) - (b.id_soal || 0);
        //         });
        //         // Simpan daftar soal ke state
        //         setSoalList(soalList);
        //     } else {

        //         setSoalList([]); // Kosongkan jika tidak ada soal
        //     }
        //     setIsloadngloadData(false)

        // } catch (error) {
        //     setIsloadngloadData(false)
        //     console.error("Error saat mengambil data:", error);
        // }
        setIsloadngloadData(false)
    };



    const getDocumentsByIds = async (documentIds) => {
        try {
            let documents = [];

            // Memecah array ID menjadi kelompok maksimal 30
            const chunkSize = 30;
            for (let i = 0; i < documentIds.length; i += chunkSize) {
                const chunk = documentIds.slice(i, i + chunkSize); // Ambil maksimal 30 ID

                const colRef = collection(db, "soal"); // Ganti dengan nama koleksi Firestore
                const q = query(colRef, where("__name__", "in", chunk)); // "__name__" adalah ID dokumen
                const querySnapshot = await getDocs(q);

                querySnapshot.docs.forEach((doc) => {
                    documents.push({
                        id: doc.id,
                        ...doc.data(),
                    });
                });
            }
            return documents;
        } catch (error) {
            console.error("Error mengambil data:", error);
            return [];
        }
    };
    const handlePilihFile = (e, lokasi) => {
        e.preventDefault();
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = "image/*"; // Hanya gambar
        fileInput.onchange = (e) => {
            const file = e.target.files[0];
            if (file) {

                handleUpload(file, lokasi);
            }
        };
        fileInput.click(); // Memicu dialog pemilih file
    };

    const handleUpload = (image, lokasi) => {
        if (!image) return;
            // Cek ukuran gambar
            if (image.size > 5 * 1024 * 1024) { // Jika lebih dari 5MB
                new Compressor(image, {
                    quality: 0.6, // Kompresi kualitas
                    maxWidth: 1920, // Maksimum lebar
                    maxHeight: 1080, // Maksimum tinggi
                    success: (compressedFile) => {
                        console.log("Gambar dikompresi:", compressedFile);
                        uploadToFirebase(compressedFile, lokasi);
                    },
                    error: (err) => {
                        console.error("Kompresi gagal:", err);
                    },
                });
            } else {
                uploadToFirebase(image, lokasi);
            }
       
    };
    const uploadToFirebase = (image, lokasi) => {

        const storageRef = ref(storage, informasiAkun.wa_number + '/imgsoaljawaban/' + image.name);
        const uploadTask = uploadBytesResumable(storageRef, image);


        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const prog = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setIsLoading(true);
                const load = document.getElementById("loadimg");


                // Menampilkan progress pada elemen
                load.innerText = `${prog.toFixed(2)}%`; // Menampilkan nilai progress dalam bentuk persen dengan 2 angka di belakang koma

                // Memperbarui lebar progress bar
                load.style.width = `${prog}%`;
                load.setAttribute('aria-valuenow', prog); // Memperbarui nilai aria-valuenow

                // Menampilkan progress bar container jika ada upload
                // load.style.display = 'block';
            },
            (error) => {
                console.error("Error uploading file: ", error);
                setIsLoading(false);
            },

            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    insertImageToEditor(downloadURL, lokasi);
                    console.log("File available at: ", downloadURL);
                    prevImagesRef.current.push(downloadURL)
                    setIsLoading(false);
                    console.log(prevImagesRef)
                });
            }
        );
        if (!uploadTask) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
    }

    const insertImageToEditor = (imageSrc, lokasi) => {

        const editor = document.getElementById(lokasi);
        if (editor) {
            const br = document.createElement("br");
            editor.appendChild(br);

            const img = document.createElement("img");
            img.src = imageSrc;
            img.style.maxWidth = "100%"; // Membatasi ukuran gambar
            img.style.margin = "10px 0"; // Memberi jarak antar teks dan gambar
            editor.appendChild(br);
            editor.appendChild(img); // Tambahkan gambar ke editor
        }
    };
    // Fungsi untuk menghapus gambar dari Firebase Storage
    const deleteImageFromFirebase = (imageUrl) => {
        // // Ambil hanya path file dari URL yang diberikan
        // const filePath = decodeURIComponent(imageUrl.split('?')[0].replace('https://firebasestorage.googleapis.com/v0/b/smartschool-c87d3.appspot.com/o/', ''));

        // // Buat referensi ke file di Firebase Storage
        // const imageRef = ref(storage, filePath);

        // // Coba hapus gambar
        // deleteObject(imageRef)
        //     .then(() => {
        //         console.log(`Gambar ${imageUrl} berhasil dihapus dari Firebase Storage`);
        //     })
        //     .catch((error) => {
        //         console.error(`Gagal menghapus gambar ${imageUrl} dari Firebase Storage`, error);
        //     });
    };
    const handleJenisChange = (type) => {
        setJenis(type);

        setJawaban(prev => {
            // Jika jawaban kosong, tambahkan satu jawaban default
            if (prev.length === 0) {
                return [{ id_jwb: 1, text: "", checked: false }];
            }
            // Jika memilih radio, pastikan hanya satu yang dicentang
            if (type === "objectif") {
                return prev.map((item, index) => ({
                    ...item,
                    checked: index === 0 // Hanya item pertama yang dicentang
                }));
            }else if(type === "essay"){
                return prev.map(item => ({ ...item, checked: false }));

            } else {
                // Jika kembali ke checkbox, tetap biarkan data seperti sebelumnya
                return prev.map(item => ({ ...item, checked: false }));
            }
        });
        setEditors((prevEditors) => [...prevEditors, `in${type}${1}`]);


    };


    const handleAddJawaban = () => {
        const newId = jawaban.length + 1; // ID baru berdasarkan jumlah elemen dalam array
        setJawaban([...jawaban, { id_jwb: newId, text: "", kunci: 0 }]);
        setEditors((prevEditors) => [...prevEditors, `in${jenis}${newId}`]);

    };

    const handleCheckboxChange = (id) => {
        setJawaban(prev =>
            prev.map(item => (item.id_jwb === id ? { ...item, kunci: !item.kunci === true ? 1 : 0 } : item))
        );
    };

    const handleSoalMapCheckboxChange = (id) => {
        setSoalmap(prev => {
            if (prev.includes(id)) {
                return prev.filter(item => item !== id); // Hapus jika sudah dipilih
            } else {
                return [...prev, id]; // Tambahkan jika belum dipilih
            }
        });
    };
    const handleRadioboxChange = (id) => {
        setJawaban(prev =>
            prev.map(item => ({
                ...item,
                kunci: item.id_jwb === id ? 1 : 0 // Set kunci menjadi 1 untuk id yang dipilih, yang lainnya menjadi 0
            }))
        );
    };

    const handleInput = (e) => {
        // Mendapatkan elemen editor
        const anchorTags = editor.querySelectorAll("a");
        anchorTags.forEach((anchor) => {
            const parent = anchor.parentNode;
            while (anchor.firstChild) {
                parent.insertBefore(anchor.firstChild, anchor);
            }
            parent.removeChild(anchor);
        });
        // Mengambil semua tag gambar di dalam editor
        const imgTags = editor.querySelectorAll("img");
        const currentImages = Array.from(imgTags).map(img => img.getAttribute("src"));

        // Periksa gambar yang dihapus (jika ada) dan hapus dari Firebase
        prevImagesRef.current.forEach((imgSrc) => {
            if (!currentImages.includes(imgSrc)) {
                deleteImageFromFirebase(imgSrc);
            }
        });

        // Update gambar yang tersisa untuk referensi berikutnya
        prevImagesRef.current = currentImages;

        // Menangani format teks
        if (!editor.textContent) {
            // Mengambil status format teks yang terblok
            const isCurrentlyBold = document.queryCommandState("bold");
            const isCurrentlyItalic = document.queryCommandState("italic");
            const isCurrentlyUnderline = document.queryCommandState("underline");
            const isCurrentlyList = document.queryCommandState("insertUnorderedList");
            const isCurrentlyOrderedList = document.queryCommandState("insertOrderedList");

            console.log(isCurrentlyBold)

            // Mengubah status format teks berdasarkan kondisi
            if (isBold !== isCurrentlyBold) {

                document.execCommand("bold");
            }
            if (isItalic !== isCurrentlyItalic) {
                document.execCommand("italic");
            }
            if (isUnderline !== isCurrentlyUnderline) {
                document.execCommand("underline");
            }
            if (isList !== isCurrentlyList) {
                document.execCommand("insertUnorderedList");
            }
            if (isListNumber !== isCurrentlyOrderedList) {
                document.execCommand("insertOrderedList");
            }
        }
    };
    const handlePaste = (event) => {
        event.preventDefault(); // Mencegah aksi default paste
        let isImagePasted = false;
        const target = event.currentTarget.id
        const clipboardItems = event.clipboardData.items;
        const clipboardText = event.clipboardData.getData("text/plain"); // Dapatkan teks dari clipboard

        // Mengecek apakah yang di-paste adalah URL gambar
        if (isImageUrl(clipboardText)) {
            isImagePasted = true;
            insertImageToEditor(clipboardText, target);
        } else {
            isImagePasted = false;
            for (let i = 0; i < clipboardItems.length; i++) {
                const item = clipboardItems[i];

                if (item.type.indexOf("image") !== -1) {
                    // Jika item adalah gambar, simpan ke Firebase Storage
                    const file = item.getAsFile();
                    handleUpload(file, target);
                    break;
                }
            }
        }

        if (!isImagePasted) {
            document.execCommand("insertText", false, clipboardText);
        }

    };

    const isImageUrl = (url) => {
        // Pola regex untuk mendeteksi URL gambar
        const imageUrlPattern = /\.(jpeg|jpg|gif|png|svg)$/i;
        return imageUrlPattern.test(url); // Mengembalikan true jika URL sesuai dengan pola gambar
    };
    useEffect(() => {
        editors.forEach((editorId) => {
            const editor = document.getElementById(editorId);
            if (editor) {
                editor.addEventListener('paste', handlePaste);
            }
        });
        console.log(editors)

        // Bersihkan event listener saat komponen di-unmount atau saat editor baru ditambahkan
        return () => {
            editors.forEach((editorId) => {
                const editor = document.getElementById(editorId);
                if (editor) {
                    editor.removeEventListener('paste', handlePaste);
                }
            });
        };
    }, [editors]);
    const handleSaveSoal = async () => {

        if(jenis==""){
            Swal.fire("Peringatan!", "Silahkan Pilih Jenis Jawaban Terlebih Dahulu", "warning");
            return;
        }

        if (isLoadingSave) return; // Mencegah klik berulang saat loading

        setIsLoadingSave(true); // Tombol dinonaktifkan saat proses dimulai

        let soalText = document.getElementById("text-editor")?.innerHTML || "";

        if (!soalText.trim()) {
            Swal.fire("Peringatan!", "Soal atau Jawaban tidak boleh kosong!", "warning");
            setIsLoadingSave(false);
            return;
        }

        const updatedJawaban = jawaban.map((item, index) => ({
            ...item,
            text: document.getElementById(`in${jenis}${index + 1}`)?.innerHTML || item.text
        }));

        const newSoal = {
            poin,
            npsn: informasiAkun.npsn,
            id_soal: soallis.length + 1,
            guru_id: informasiAkun.data_id,
            id_mapel: data.id_mapel,
            id_rombel: data.id_rombel,
            pembelajaran_id: data.pembelajaran_id,
            nama_rombel: data.nama_rombel,
            soal: soalText,
            jenis,
            jawaban: jenis === "essay" ? [] : updatedJawaban,
            createdAt: new Date() // Menyimpan timestamp
        };

        try {
            // Simpan soal ke Firestore
            const docRef = await addDoc(collection(db, "soal"), newSoal);
            const soalId = docRef.id;
            console.log("Soal berhasil disimpan dengan ID:", soalId);


            // Kirim update ke server
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pendidik/updateujiansoal`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify({ id_ujian, soal: JSON.stringify([...soallisid, soalId]) }),
            });

            if (!response.ok) {
                throw new Error("Gagal menyimpan data ke server");
            }

            const result = await response.json();
            Swal.fire("Berhasil!", result.message, "success");
            setSoalListId(prevSoallis => [...prevSoallis, soalId]);
            // Reset form
            document.getElementById("text-editor").innerHTML = "";
            setIsBold(false);
            setIsItalic(false);
            setIsUnderline(false);
            setIsList(false);
            setListNumber(false);

            setJawaban(prevJawaban =>
                prevJawaban.map(item => ({
                    ...item,
                    kunci: 0,
                    text: ""
                }))
            );

            jawaban.forEach((_, index) => {
                const el = document.getElementById(`in${jenis}${index + 1}`);
                if (el) el.innerHTML = "";
            });

            setTimeout(() => {
                document.getElementById("baru")?.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 500);
            const results = await getDocumentsByIds([soalId]);
            //setFetchTrigger(prev => prev + 1);

            setSoalList((prevSoalList)=>[...prevSoalList, results[0]]);
            console.log(results)
      
        } catch (error) {
            console.error("Error saat menyimpan:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat menyimpan soal", "error");
        } finally {
            setIsLoadingSave(false);
        }
    };




    const handleMaping = async (pembelajaranparm) => {
        if (!soalmap || soalmap.length === 0) {
            Toastify({
                text: "Soal belum ada yg dipilih",
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "red",
            }).showToast();
            return;
        }


        if (!pembelajaranparm) {
            Toastify({
                text: "Pilih 1 atau lebih pembelajaran",
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "red",
            }).showToast();
            return;
        }

        try {
            const batch = writeBatch(db);

            for (const idp of pembelajaranparm) {
                for (const soal of soalmap) {
                    const soalRef = doc(db, `ujian/${idp}/soal`, soal.id);
                    batch.set(soalRef, {
                        soalId: soal.id,
                        urutan: soal.urutan || Date.now(), // Gunakan urutan dari soalMap jika ada, jika tidak pakai timestamp
                    });
                }
            }

            await batch.commit(); // Eksekusi semua perubahan dalam satu transaksi

            console.log("Referensi soal berhasil ditambahkan ke ujian dengan ID:", pembelajaranparm);

            Toastify({
                text: "Soal berhasil dimapping!",
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "#4CAF50",
            }).showToast();

        } catch (error) {
            console.error("Error:", error);
            alert("Terjadi kesalahan saat menyimpan soal");
        }
    };


    const handleEditClick = ((soal, id) => {
        setSelectedSoal(soal);
        setTimeout(() => {
            // Scroll ke data yang baru ditambahkan (dengan ID yang sesuai)
            let newDataElement = document.getElementById(id);
            if (newDataElement) {
                newDataElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 200);
    });
    const handleSaveUpdateSoal = async (dataedit, id) => {

        console.log(dataedit);

        try {
            // Referensi dokumen soal berdasarkan ID
            const soalRef = doc(db, "soal", id);

            // Update Firestore
            await updateDoc(soalRef, dataedit);
            console.log("Soal berhasil diperbarui di Firebase");

            // Tampilkan notifikasi sukses
            Toastify({
                text: "Soal berhasil disimpan!",
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "#4CAF50",
            }).showToast();

            // Reset editor
            document.getElementById("text-editor").innerHTML = "";
            setFetchTrigger((prev) => prev + 1);
            setSelectedSoal(false);

            // Jika ingin merefresh data setelah update
        } catch (error) {
            console.error("Error updating soal:", error);
            alert("Terjadi kesalahan saat menyimpan soal");
        }
    };







  
        const handleHapusSoal = async (idSoal) => {
            const result = await Swal.fire({
                title: "Apakah Anda yakin?",
                text: "Soal ini akan dihapus dari daftar ujian ini, soal ini tidak dihapus dari daftar ujian yg lain jika telah di maping!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Ya, hapus!",
                cancelButtonText: "Batal",
                reverseButtons: true, // Membalik tombol OK & Batal untuk UX yang lebih baik
            });
        
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pendidik/updateujiansoal`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${localStorage.getItem('authToken')}`,
                        },
                        body: JSON.stringify({ 
                            id_ujian, 
                            soal: JSON.stringify(soallisid.filter(id => id !== idSoal)) 
                        }),
                    });
        
                    if (!response.ok) {
                        throw new Error("Gagal menyimpan data ke server");
                    }
        
                    const result = await response.json();
                    Swal.fire({
                        title: "Berhasil!",
                        text: result.message,
                        icon: "success",
                        confirmButtonColor: "#3085d6",
                    });
                    setSoalListId(prevSoallis => prevSoallis.filter(id => id !== idSoal));
                    setSoalList(prevSoalList => prevSoalList.filter(soal => soal.id !== idSoal));
        
                } catch (error) {
                    console.error("Error:", error);
                    Swal.fire({
                        title: "Gagal!",
                        text: "Terjadi kesalahan saat menghapus soal.",
                        icon: "error",
                        confirmButtonColor: "#d33",
                    });
                }
            }
        };
        

    const hendelCloseEdit = () => {
        setSelectedSoal(false);
    }
    const bukaModalmaping = () => {
        const modal = new window.bootstrap.Modal(document.getElementById("myModal"));
        modal.show();
    }

    const ganrateGform = async () => {
        setIsloadngloadData(true)
        const urlGform = document.getElementById("gformurl").value;


        console.log({ urlgform: urlGform })
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pendidik/get-form-data`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
                },
                body: JSON.stringify({
                    urlgform: urlGform,
                    guru_id: informasiAkun.data_id,
                    id_mapel: data.id_mapel,
                    id_rombel: data.id_rombel,
                    pembelajaran_id: data.pembelajaran_id,
                    nama_rombel: data.nama_rombel,
                    nama_mapel: data.nama_mapel
                }),
            });

            if (!response.ok) {
                throw new Error("Gagal menyimpan soal");
            }

            const result = await response.json();

            setGform(result)
            console.log(result);

            document.getElementById('btn-closemaping').click();

            setIsloadngloadData(false)
        } catch (error) {
            setIsloadngloadData(false)
            console.error("Error:", error);
            alert("Terjadi kesalahan saat menyimpan soal");
        }
    }
    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSoalGformPilih([...gform]); // Centang semua item dengan duplikasi array
        } else {
            setSoalGformPilih([]); // Hapus semua centang
        }
    };
    const handleSelectAllForMaping = (event) => {

        if (event.target.checked) {
            setSoalmap([...soallis]); // Centang semua item dengan duplikasi array
        } else {
            setSoalmap([]); // Hapus semua centang
        }
        console.log(soalmap)
    };

    const handleItemChange = (item) => {
        setSoalGformPilih((prevData) => {
            const exists = prevData.some((i) => i.id_soal === item.id_soal);

            if (exists) {
                return prevData.filter((i) => i.id_soal !== item.id_soal);
            } else {
                return [...prevData, { ...item }]; // Pastikan objek baru untuk memicu re-render
            }
        });
    };



    const handleSave = async () => {
        setIsloadngloadData(true)
        try {
            const batch = writeBatch(db);
            const quizCollection = collection(db, "soal");

            for (const soal of soalGformPilih) {
                const docRef = doc(quizCollection); // Buat dokumen baru otomatis untuk soal utama
                const soalId = docRef.id; // Dapatkan ID dokumen yang dibuat

                // Simpan soal ke koleksi utama "soal"
                batch.set(docRef, {
                    ...soal,
                    createdAt: new Date(),
                });

                // Simpan referensi ID soal ke dalam subkoleksi "ujian/{id_ujian}/soal/{id_soal}"
                const soalRef = doc(db, `ujian/${id_ujian}/soal`, soalId);
                batch.set(soalRef, {
                    soalId: soalId,
                    urutan: Date.now(), // Bisa diubah nanti sesuai kebutuhan
                });
            }

            await batch.commit(); // Simpan semua data dalam satu batch
            Toastify({
                text: "Semua Soal Dipilih Berhasil Disimpan",
                duration: 3000, // Duration in milliseconds
                close: true,
                gravity: "top", // "top" or "bottom"
                position: "right", // "left", "center", or "right"
                backgroundColor: "#4CAF50", // Green background for success
            }).showToast();
            setFetchTrigger((prev) => prev + 1);
            setIsloadngloadData(false)
        } catch (error) {
            setIsloadngloadData(false)
            console.error("Error menyimpan soal: ", error);
        }
    };


    const handleCheckboxChangeGForm = (idSoal, idJwb) => (e) => {
        const isChecked = e.target.checked ? 1 : 0;

        setSoalGformPilih((prevData) =>
            prevData.map((item) =>
                item.id_soal === idSoal
                    ? {
                        ...item,
                        jawaban: item.jawaban.map((item2) =>
                            item2.id_jwb === idJwb ? { ...item2, kunci: isChecked } : item2
                        ),
                    }
                    : item
            )
        );
        console.log(soalGformPilih)
    };

    useEffect(() => {

        fetchKelas();
        getAkun();
        didMount.current = true; // Menandai bahwa fungsi sudah dieksekusi

    }, []);


    useEffect(() => {
        fetchKelas();
    }, [fetchTrigger]);
    return (
        <>
            {loadngloadData && (
                <div style={overlayStyle}>
                    <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            <div className="pc-container">
                <div className="pc-content" key='detaildata'>
                    <div className="row d-flex flex-wrap" >
                        <div className="col-xl-12 col-md-12" >
                            <div className="card">
                                <div className="card-header">
                                    <h5>Daftar Ujian</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row g-4">
                                        <div className="col-md-4">
                                            <h5>Pendidik</h5>
                                            <hr />
                                            <h5>{data.nama_guru}</h5>
                                        </div>
                                        <div className="col-md-4">
                                            <h5>Kelas</h5>
                                            <hr />
                                            <h5>{data.nama_rombel}</h5>
                                        </div>
                                        <div className="col-md-4">
                                            <h5>Pelajaran</h5>
                                            <hr />
                                            <h5>{data.nama_mapel}</h5>
                                        </div>
                                    </div>
                                    <hr />
                                    <a href='#baru' className="btn btn-primary d-inline-flex"><i className='ti ti-plus'></i> Soal baru</a>

                                    <button type="button" className="btn btn-danger d-inline-flex" onClick={bukaModalmaping}><i className='ti ti-arrows-split'></i> Maping Soal</button>
                                    <button type="button" className="btn btn-secondary d-inline-flex" data-bs-toggle="modal" data-bs-target="#modalgoogleform"><i className='ti ti-arrows-split'></i> Salin Dari Google Formulir</button>

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-xl-12 d-flex mb-3">
                            <div className="card w-100">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between  row ">
                                        <div className="form-check form-check-inline col">
                                            <input className="form-check-input" id="customCheckinlh3"
                                                type="checkbox"
                                                onChange={handleSelectAllForMaping}

                                            />
                                            <label className="form-check-label" htmlFor="customCheckinlh3">Pilih Semua</label>
                                        </div>
                                        <div className='col-auto'>
                                            Total Poin :
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {soallis.map((soal, index) => (
                            selectedSoal && selectedSoal.id === soal.id ? (
                                <EditSoal
                                    key={"edt" + soal.id} // Key untuk komponen EditSoal
                                    editData={soal}
                                    onSave={handleSaveUpdateSoal}
                                    informasiAkun={informasiAkun}
                                    onCancle={hendelCloseEdit}
                                />
                            ) : (
                                <div key={soal.id} id={"heade" + soal.id} className="col-sm-12 col-md-12 col-xl-12 d-flex mb-3">
                                    <div className="card w-100 d-flex flex-column">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between mb-3 row">
                                                <div className="form-check form-check-inline col">
                                                    <input
                                                        className="form-check-input"
                                                        id={"customCheck" + soal.id} // ID unik untuk setiap checkbox
                                                        value={soal.id}
                                                        onChange={() => handleSoalMapCheckboxChange(soal.id)}
                                                        type="checkbox"
                                                        checked={soalmap.some((i) => i.id_soal === soal.id_soal)}
                                                    />
                                                    <label className="form-check-label" htmlFor={"customCheck" + soal.id}>
                                                        NO : {index + 1}
                                                    </label>
                                                </div>
                                                <div className="col-auto">
                                                    Poin : {soal.poin}
                                                </div>
                                                <div className="dropdown col-auto">
                                                    <a
                                                        className="avtar avtar-s btn-link-secondary dropdown-toggle arrow-none"
                                                        href="#"
                                                        data-bs-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        <i className="ti ti-dots-vertical f-18"></i>
                                                    </a>
                                                    <div className="dropdown-menu dropdown-menu-end">
                                                        <a
                                                            className="dropdown-item text-yellow-900"
                                                            href="#"
                                                            onClick={(e) => { e.preventDefault(); handleEditClick(soal, soal.id); }}
                                                        >
                                                            Ubah
                                                        </a>
                                                        <a
                                                            className="dropdown-item text-red-900"
                                                            href="#"
                                                            onClick={(e) => { e.preventDefault(); handleHapusSoal(soal.id); }}
                                                        >
                                                            Hapus
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr />
                                            <SoalCard key={soal.id} soal={soal} />
                                        </div>
                                    </div>
                                </div>
                            )
                        ))}


                        {/* Modal Edit Soal */}


                        <div className="col-sm-12 col-md-12 col-xl-12" id='baru'>
                            <div className="card">
                                <div className="card-body">
                                    <div className="row justify-content-between align-items-center"><h4 className='col'>Soal Baru</h4>

                                        <div className='row col-auto '>
                                            <div className="col-sm-6 col-md-6 col-xl-6" id='baru'>
                                            <input 
                                                            type="number"  
                                                            id="poin" 
                                                            className="form-control" 
                                                            placeholder="Poin" 
                                                            value={poin} 
                                                            onChange={(e) => setPoin(Math.max(1, Number(e.target.value)))}  
                                                            min="1" 
                                                        />
                                             </div>
                                            <div className="col-sm-6 col-md-6 col-xl-6" id='baru'>
                                                <button
                                                    className="col-auto btn btn-primary"
                                                    type="button"
                                                    onClick={handleSaveSoal}
                                                    disabled={isLoadingSave}>
                                                    <i className="ti ti-file-symlink"></i>
                                                    {isLoadingSave ? (
                                                        <>
                                                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                                            Loading...
                                                        </>
                                                    ) : (
                                                        "Simpan"
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row g-4">
                                        <div className="col-md-12">
                                            <div className='d-flex flex-wrap gap-2 mb-4'>
                                                <button type="button" onClick={() => handleBold(setIsBold)} className={`btn btn-icon btn-outline-dark ${isBold ? "active" : ""}`} ><i className="ti ti-Bold"></i></button>
                                                <button type="button" onClick={() => handleItalic(setIsItalic)} className={`btn btn-icon btn-outline-dark ${isItalic ? "active" : ""}`}><i className="ti ti-Italic"></i></button>
                                                <button type="button" onClick={() => handleUnderline(setIsUnderline)} className={`btn btn-icon btn-outline-dark ${isUnderline ? "active" : ""}`}><i className="ti ti-underline"></i></button>
                                                <button type="button" onClick={() => handleList(setIsList)} className={`btn btn-icon btn-outline-dark ${isList ? "active" : ""}`}><i className="ti ti-list"></i></button>
                                                <button type="button" onClick={() => handleOrderedList(setListNumber)} className={`btn btn-icon btn-outline-dark ${isListNumber ? "active" : ""}`}><i className="ti ti-list-numbers"></i></button>
                                                <button type="button" onClick={(e) => handlePilihFile(e, "text-editor")} className="btn btn-icon btn-outline-dark"><i className="ti ti-photo"></i></button>
                                            </div>
                                            <div>
                                                <div className="progress mb-4" style={{ height: "20px", display: isLoading ? 'block' : 'none', }}>
                                                    <div id='loadimg'
                                                        className="progress-bar"
                                                        role="progressbar"
                                                        style={{}}

                                                        aria-valuenow={progressRef.current}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100">
                                                        {progressRef.current} %
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                id="text-editor"
                                                className='editor'
                                                contentEditable
                                                style={{ minHeight: '50px', borderBottom: '1px solid #ccc', padding: '10px' }}
                                                onInput={handleInput}
                                                suppressContentEditableWarning={true}


                                            />
                                        </div>
                                        <div className="col-md-12">

                                            <div className="btn-group dropstart">
                                                <button type="button" className="btn btn-light-secondary">
                                                    Jenis Jawaban
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-light-secondary dropdown-toggle dropdown-toggle-split"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <span className="visually-hidden">Toggle Dropdown</span>
                                                </button>
                                                <div className="dropdown-menu">
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => handleJenisChange("objectif")}
                                                    >
                                                        Jawaban Objektif
                                                    </button>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => handleJenisChange("ganda")}
                                                    >
                                                        Ceklis
                                                    </button>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => handleJenisChange("essay")}
                                                    >
                                                        Esay
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="mt-4">
                                                {/* Render berdasarkan jenis jawaban */}
                                                {jenis === "objectif" && (
                                                    <div>
                                                        <h5>Jawaban Objektif (Radio)</h5>
                                                        {jawaban.map((item, index) => (
                                                            <div key={'objectif' + index} className="d-flex align-items-center mb-2 col-md-12">
                                                                <div className="input-group mb-3">
                                                                    <span className="input-group-text">
                                                                        <input
                                                                            checked={item.kunci === 1 ? true : false}
                                                                            onChange={() => handleRadioboxChange(item.id_jwb)}
                                                                            className="form-check-input input-light-primary" name='jawaban[]' type="radio" id="customCheckclight1" />
                                                                    </span>
                                                                    <span className="input-group-text">
                                                                        <button type="button" onClick={(e) => handlePilihFile(e, "in" + jenis + (index + 1))} className="btn btn-icon btn-outline-dark"><i className="ti ti-photo"></i></button>
                                                                    </span>
                                                                    <div
                                                                        id={"in" + jenis + (index + 1)}
                                                                        className="editor"
                                                                        contentEditable
                                                                        style={{ minHeight: '50px', border: '1px solid #ccc', padding: '10px', flex: "1 1 auto" }}
                                                                        suppressContentEditableWarning={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        ))}
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary"
                                                            onClick={handleAddJawaban}
                                                        >
                                                            Tambah Jawaban
                                                        </button>
                                                    </div>
                                                )}

                                                {jenis === "ganda" && (
                                                    <div>
                                                        <h5>Ceklis (Checkbox)</h5>
                                                        {jawaban.map((item, index) => (
                                                            <div key={'ganda' + index} className="d-flex align-items-center mb-2 col-md-12">
                                                                <div className="input-group mb-3">
                                                                    <span className="input-group-text">
                                                                        <input
                                                                            checked={item.kunci === 1 ? true : false}
                                                                            onChange={() => handleCheckboxChange(item.id_jwb)}
                                                                            className="form-check-input input-light-primary" name='jawaban[]' type="checkbox" id="customCheckclight1" />
                                                                    </span>
                                                                    <span className="input-group-text">
                                                                        <button type="button" onClick={(e) => handlePilihFile(e, "in" + jenis + (index + 1))} className="btn btn-icon btn-outline-dark"><i className="ti ti-photo"></i></button>
                                                                    </span>
                                                                    <div
                                                                        id={"in" + jenis + (index + 1)}
                                                                        className="editor"
                                                                        contentEditable
                                                                        style={{ minHeight: '50px', border: '1px solid #ccc', padding: '10px', flex: "1 1 auto" }}

                                                                        suppressContentEditableWarning={true}


                                                                    />

                                                                </div>
                                                            </div>

                                                        ))}
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary"
                                                            onClick={handleAddJawaban}
                                                        >
                                                            Tambah Jawaban
                                                        </button>
                                                    </div>
                                                )}
                                                {jenis === "essay" && (
                                                    <div>
                                                        <h5>Essay Jawaban, Jawaban isi untuk menjadi pedoman dan update fitur koreksi otomatis dimasa depan</h5>
                                                        <div
                                                                        id={"in" + jenis + (1)}
                                                                        className="editor"
                                                                        contentEditable
                                                                        style={{ minHeight: '50px', border: '1px solid #ccc', padding: '10px', flex: "1 1 auto" }}

                                                                        suppressContentEditableWarning={true}


                                                                    />

                                                       
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className="row justify-content-between align-items-center"><h4 className='col'>Tindakan</h4>

                                        <button
                                            className="col-auto btn btn-primary"
                                            type="button"
                                            onClick={handleSaveSoal}
                                            disabled={isLoadingSave}>
                                            <i className="ti ti-file-symlink"></i>
                                            {isLoadingSave ? (
                                                <>
                                                    <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                                    Loading...
                                                </>
                                            ) : (
                                                "Simpan"
                                            )}
                                        </button>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12"  >

                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="myModal" >
                <div className="modal-dialog  modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Maping Soal</h5>
                            <button type="button" className="btn-close" id='btn-closemaping' data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <Maping onSave={handleMaping} soal={soalmap} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalgoogleform" >
                <div className="modal-dialog  modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Maping Soal</h5>
                            <button type="button" className="btn-close" id='btn-closemaping' data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label className="form-label">Link Google Formulir</label>
                                    <div className="input-group">
                                        <input id='gformurl' type="text" className="form-control" placeholder="Url" />
                                        <button className="btn btn-outline-secondary" onClick={ganrateGform} type="button">Ganrate Soal</button>
                                    </div>

                                </div>
                            </form>

                            <div className="p-4">
                                {/* Checkbox Pilih Semua */}
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        className="form-checkbox"
                                        checked={soalGformPilih.length === gform.length}
                                        onChange={handleSelectAll}
                                    />
                                    <span>Pilih Semua</span>
                                </label>
                            </div>

                            <div className="mt-2 space-y-2">
                                {gform.map((item, index2) => (
                                    <div className="list-group" key={index2}>
                                        <label className="list-group-item">
                                            <input
                                                type="checkbox"
                                                className="form-check-input me-1"
                                                checked={soalGformPilih.some((i) => i.id_soal === item.id_soal)}
                                                onChange={() => handleItemChange(item)}
                                            />
                                            <span dangerouslySetInnerHTML={{ __html: item.soal }}></span>
                                            <ul className="list-group">
                                                {item?.jawaban?.map((item2, index) => (
                                                    <li className="list-group-item" key={`${item.id_soal}-${item2.id_jwb}`}>
                                                        <label className="list-group-item">
                                                            <input
                                                                className="form-check-input me-1"
                                                                type="checkbox"

                                                                onChange={handleCheckboxChangeGForm(item.id_soal, item2.id_jwb)}
                                                            />
                                                            <span dangerouslySetInnerHTML={{ __html: item2.text }}></span>
                                                        </label>
                                                    </li>
                                                ))}
                                            </ul>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" onClick={handleSave} className="btn btn-primary">Simpan</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
const SoalCard = (({ soal }) => {
    return (<div>
        {/* {parse(soal.soal)} */}
        <div key={"soaltext" + soal.id} dangerouslySetInnerHTML={{ __html: soal.soal }} />
        <hr />
        <b>Jawaban <span style={{ color: '#78d9e2' }}>[ {soal.jenis} ]</span></b>
        <br /><br />
        <div key={"soaljawaban" + soal.id} style={{ paddingLeft: "20px" }}>
            <ul className="list-group list-group-flush">
                {soal.jawaban.map((jawaban, index) => (
                    <li key={jawaban.id_jwb || index} className="list-group-item px-0 d-flex align-items-center">
                        <div className="flex-shrink-0">
                            {
                                soal.jenis === "ganda" ? (
                                    <input disabled className="form-check-input input-success" type="checkbox" defaultChecked={jawaban.kunci === 1} />
                                ) :  soal.jenis === "essay" ?(
                                    <div></div>
                                ): (
                                    <input disabled className="form-check-input input-success" type="radio" defaultChecked={jawaban.kunci === 1} />
                                )
                            }
                        </div>
                        <div className="flex-grow-1 ms-3">
                            <div className="row g-1">
                                <div className="col-6">
                                    <div dangerouslySetInnerHTML={{ __html: jawaban.text }} />

                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    </div>

    );
});
export default ViewEvaluasi;
